<template>
    <section class="page-header -type-1" >
        <div class="container" :class="activePromotion? 'pt-20' : 'pt-50'">
            <div class="page-header__content">
                <div class="row justify-between">
                    <div class="col-12">
                        <div class="sectionTitle pt-20">
                            <h1 class="sectionTitle__title">{{ $t('browseCourses.title') }}</h1>
                        </div>

                        <div class="d-flex justify-between flex-column flex-lg-row">
                            <div>
                                <p class="page-header__text">{{ $t('browseCourses.description') }}</p>
                            </div>

                            <!----------Filteration sidebar------------->
                            <div class="accordion js-accordion mt-10">
                                <div class="accordion__item">
                                    <div class="row items-center justify-between">
                                        <!---Filteration result-->
                                        <div class="col-auto">
                                            <div class="text-16 fw-bold lh-12">
                                                {{ $t('resultsInfo.showing') }}
                                                <span class="text-dark-1 fw-500"> {{ coureListLength }} </span>
                                                {{ $t('resultsInfo.totalResults') }}
                                            </div>
                                        </div>
                                        <!----->
                                        <!------- start of Filter Sidebar for small screens ----------------->
                                        <div class="col-auto">
                                            <div class="row x-gap-20 y-gap-20">
                                                <div class="col-auto">
                                                    <div class="d-flex items-center">
                                                        <!----<div class="">
                                                            -- Custom Select Button --
                                                            <div class="custom-select" @click="toggleDropdown"
                                                                :class="{ active: isDropdownVisible }">
                                                                <div class="custom-select__button">
                                                                    <span>{{ selectedOption }}</span>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                        height="24" viewBox="0 0 24 24" fill="none">
                                                                        <path
                                                                            d="M6.29243 4.293C6.47996 4.10553 6.73427 4.00021 6.99943 4.00021C7.2646 4.00021 7.5189 4.10553 7.70643 4.293L11.7064 8.293C11.8886 8.4816 11.9894 8.7342 11.9871 8.9964C11.9848 9.2586 11.8797 9.50941 11.6942 9.69482C11.5088 9.88023 11.258 9.9854 10.9958 9.98767C10.7336 9.98995 10.481 9.88916 10.2924 9.707L7.99943 7.414V19C7.99943 19.2652 7.89407 19.5196 7.70654 19.7071C7.519 19.8946 7.26465 20 6.99943 20C6.73421 20 6.47986 19.8946 6.29232 19.7071C6.10479 19.5196 5.99943 19.2652 5.99943 19V7.414L3.70643 9.707C3.51783 9.88916 3.26523 9.98995 3.00303 9.98767C2.74083 9.9854 2.49002 9.88023 2.30461 9.69482C2.1192 9.50941 2.01403 9.2586 2.01176 8.9964C2.00948 8.7342 2.11027 8.4816 2.29243 8.293L6.29243 4.293ZM15.9994 16.586V5C15.9994 4.73478 16.1048 4.48043 16.2923 4.29289C16.4799 4.10536 16.7342 4 16.9994 4C17.2646 4 17.519 4.10536 17.7065 4.29289C17.8941 4.48043 17.9994 4.73478 17.9994 5V16.586L20.2924 14.293C20.481 14.1108 20.7336 14.01 20.9958 14.0123C21.258 14.0146 21.5088 14.1198 21.6942 14.3052C21.8797 14.4906 21.9848 14.7414 21.9871 15.0036C21.9894 15.2658 21.8886 15.5184 21.7064 15.707L17.7064 19.707C17.5189 19.8945 17.2646 19.9998 16.9994 19.9998C16.7343 19.9998 16.48 19.8945 16.2924 19.707L12.2924 15.707C12.1103 15.5184 12.0095 15.2658 12.0118 15.0036C12.014 14.7414 12.1192 14.4906 12.3046 14.3052C12.49 14.1198 12.7408 14.0146 13.003 14.0123C13.2652 14.01 13.5178 14.1108 13.7064 14.293L15.9994 16.586Z"
                                                                            fill="#09445D" />
                                                                    </svg>
                                                                </div>
                                                                -- Dropdown Options --
                                                                <div class="custom-select__options"
                                                                    v-if="isDropdownVisible">
                                                                    <div class="text-14 y-gap-15 js-dropdown-list">
                                                                        <div v-for="option in dropdownOptions"
                                                                            :key="option">
                                                                            <a href="#"
                                                                                @click.stop.prevent="selectOption(option)">{{
                                                                                    option }}</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>-->
                                                    </div>
                                                </div>

                                                <div class="col-auto d-none lg:d-block">
                                                    <div class="accordion__button w-unset">
                                                        <button class="button h-50 main-button fw-500 px-15 text-15"
                                                            @click="showFilterDropdown" style="gap: 2px">
                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                                width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                                <path stroke="currentColor" stroke-linecap="round"
                                                                    stroke-width="2"
                                                                    d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z" />
                                                            </svg>

                                                            Filter
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!------- end of Filter Sidebar for small screens ----------------->
                                    </div>
                                    <!------------ Filter for for small screens ----------->
                                    <div class="accordion__content filter__accordion__content"
                                        @mouseleave="showSmallMenu = false" :class="{ 'activeFilter': showSmallMenu }"
                                        v-if="showSmallMenu">
                                        <div class="sidebar -courses px-30 py-30 rounded-8 bg-light-3 mb-50">
                                            <div class="row x-gap-60 y-gap-40">
                                                <div class="col-xl-3 col-lg-4 col-sm-6">
                                                    <div class="sidebar__item">
                                                        <h5 class="sidebar__title">{{ $t('sidebar.categories') }}</h5>

                                                        <div class="sidebar-checkbox">
                                                            <div v-for="(category) in categories" :key="category.value">
                                                                <div class="sidebar-checkbox__item mb-2">
                                                                    <div class="form-checkbox">
                                                                        <input type="checkbox" :id="category.value"
                                                                            v-model="selectedCategories"
                                                                            :value="category.value"
                                                                            @change="emitSelectedCategories" />
                                                                        <div class="form-checkbox__mark">
                                                                            <div class="form-checkbox__icon icon-check">
                                                                                <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                    aria-hidden="true"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="24" height="24" fill="none"
                                                                                    viewBox="0 0 24 24">
                                                                                    <path stroke="currentColor"
                                                                                        stroke-linecap="round"
                                                                                        stroke-linejoin="round"
                                                                                        stroke-width="2"
                                                                                        d="M5 11.917 9.724 16.5 19 7.5" />
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <label :for="category.value"
                                                                        class="sidebar-checkbox__title">
                                                                        {{ category.label }}
                                                                    </label>

                                                                </div>
                                                                <!-- Recursively render children if they exist -->
                                                                <div v-if="category.children && category.children.length"
                                                                    class="sidebar-checkbox__children">
                                                                    <div class="sidebar-checkbox__item mb-2"
                                                                        v-for="(child) in category.children"
                                                                        :key="child.value">
                                                                        <div class="form-checkbox">
                                                                            <input type="checkbox" :id="child.value"
                                                                                v-model="selectedCategories"
                                                                                :value="child.value"
                                                                                @change="emitSelectedCategories" />
                                                                            <div class="form-checkbox__mark">
                                                                                <div
                                                                                    class="form-checkbox__icon icon-check">
                                                                                    <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                        aria-hidden="true"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="24" height="24"
                                                                                        fill="none" viewBox="0 0 24 24">
                                                                                        <path stroke="currentColor"
                                                                                            stroke-linecap="round"
                                                                                            stroke-linejoin="round"
                                                                                            stroke-width="2"
                                                                                            d="M5 11.917 9.724 16.5 19 7.5" />
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <label :for="child.value"
                                                                            class="sidebar-checkbox__title">
                                                                            {{ child.label }}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!---------end of filter by category----------->

                                                <!-------- start of filter by level----------
                                                <div class="col-xl-3 col-lg-4 col-sm-6">
                                                    <div class="sidebar__item">
                                                        <h5 class="sidebar__title">Level</h5>
                                                        <div class="sidebar-checkbox">
                                                            <div class="sidebar-checkbox__item">
                                                                <div class="form-checkbox">
                                                                    <input type="checkbox" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="sidebar-checkbox__title">
                                                                    All Levels
                                                                </div>
                                                            </div>

                                                            <div class="sidebar-checkbox__item">
                                                                <div class="form-checkbox">
                                                                    <input type="checkbox" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="sidebar-checkbox__title">
                                                                    Beginner
                                                                </div>
                                                            </div>

                                                            <div class="sidebar-checkbox__item">
                                                                <div class="form-checkbox">
                                                                    <input type="checkbox" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="sidebar-checkbox__title">
                                                                    Intermediate
                                                                </div>
                                                            </div>

                                                            <div class="sidebar-checkbox__item">
                                                                <div class="form-checkbox">
                                                                    <input type="checkbox" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="sidebar-checkbox__title">
                                                                    Advanced
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                -------- End  of filter by level---------->

                                                <!-------- start of filter by language----------
                                                <div class="col-xl-3 col-lg-4 col-sm-6">
                                                    <h5 class="sidebar__title">Language</h5>
                                                    <div class="sidebar-checkbox">
                                                        <div class="sidebar-checkbox__item">
                                                            <div class="form-checkbox">
                                                                <input type="checkbox" />
                                                                <div class="form-checkbox__mark">
                                                                    <div class="form-checkbox__icon icon-check">
                                                                        <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                            aria-hidden="true"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="24" height="24" fill="none"
                                                                            viewBox="0 0 24 24">
                                                                            <path stroke="currentColor"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round" stroke-width="2"
                                                                                d="M5 11.917 9.724 16.5 19 7.5" />
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="sidebar-checkbox__title">
                                                                Arabic
                                                            </div>
                                                        </div>

                                                        <div class="sidebar-checkbox__item">
                                                            <div class="form-checkbox">
                                                                <input type="checkbox" />
                                                                <div class="form-checkbox__mark">
                                                                    <div class="form-checkbox__icon icon-check">
                                                                        <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                            aria-hidden="true"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="24" height="24" fill="none"
                                                                            viewBox="0 0 24 24">
                                                                            <path stroke="currentColor"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round" stroke-width="2"
                                                                                d="M5 11.917 9.724 16.5 19 7.5" />
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="sidebar-checkbox__title">
                                                                English
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                -------- end of filter by language---------->

                                                <!-------- start of filter by rating----------
                                                <div class="col-xl-3 col-lg-4 col-sm-6">
                                                    <div class="sidebar__item">
                                                        <h5 class="sidebar__title">Ratings</h5>
                                                        <div class="sidebar-checkbox">
                                                            <div class="sidebar-checkbox__item">
                                                                <div class="form-checkbox">
                                                                    <input type="checkbox" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="sidebar-checkbox__title">
                                                                    4 stars and above
                                                                </div>
                                                            </div>

                                                            <div class="sidebar-checkbox__item">
                                                                <div class="form-checkbox">
                                                                    <input type="checkbox" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="sidebar-checkbox__title">
                                                                    4.5 stars and above
                                                                </div>
                                                            </div>

                                                            <div class="sidebar-checkbox__item">
                                                                <div class="form-checkbox">
                                                                    <input type="checkbox" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="sidebar-checkbox__title">
                                                                    5 stars
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                -------- end of filter by rating---------->

                                                <!-------- start of filter by instractor ---------->
                                                <div class="col-xl-3 col-lg-4 col-sm-6">
                                                    <div class="sidebar__item">
                                                        <h5 class="sidebar__title">
                                                            {{ $t('sidebar.instructors') }}
                                                        </h5>
                                                        <div class="sidebar-checkbox">
                                                            <div class="sidebar-checkbox__item"
                                                                v-for="instructor in instructors" :key="instructor.id">
                                                                <div class="form-checkbox">
                                                                    <!-- Use v-model to bind the checkbox to the selectedInstructors array -->
                                                                    <input type="checkbox"
                                                                        :id="'instructor-' + instructor.id"
                                                                        v-model="selectedInstructors"
                                                                        :value="instructor.id"
                                                                        @change="emitSelectedinstractors" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <label :for="'instructor-' + instructor.id"
                                                                    class="sidebar-checkbox__title">
                                                                    {{ instructor.name }}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-------- end of filter by instractor ---------->

                                                <!-------- start of filter by price----------
                                                <div class="col-xl-3 col-lg-4 col-sm-6">
                                                    <div class="sidebar__item">
                                                        <div>
                                                            <div>
                                                                <h5 class="sidebar__title mb-25">Price
                                                                </h5>
                                                            </div>
                                                            ------start of price range slider-------------
                                                            <div class="sidebar-content -slider">
                                                                <div class="js-price-rangeSlider">
                                                                    <div class="px-5">
                                                                        <div class="js-slider"></div>
                                                                    </div>

                                                                    <div class="mt-25">
                                                                        <price-filter />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            ------------free or not checkbox---------
                                                            <div class="sidebar-checkbox__item mt-20">
                                                                <div class="form-checkbox">
                                                                    <input type="checkbox" />
                                                                    <div class="form-checkbox__mark">
                                                                        <div class="form-checkbox__icon icon-check">
                                                                            <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                                                aria-hidden="true"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="24" height="24" fill="none"
                                                                                viewBox="0 0 24 24">
                                                                                <path stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M5 11.917 9.724 16.5 19 7.5" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="sidebar-checkbox__title capitalize ml-10">
                                                                    free
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>-->
                                                <!-------- end of filter by price---------->

                                            </div>
                                        </div>
                                    </div>
                                    <!------------ Filter for small Screens ----------->
                                </div>
                            </div>
                            <!------------------------------->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import clickElToggle from '@/directives/clickElToggle';
import PriceFilter from './PriceFilter.vue';
import store from '@/store';
export default {
    components: { PriceFilter },
    directives: {
        clickElToggle
    },
    data() {
        return {
            sortType: "",
            dropdownOptions: ["Animation", "Design", "Illustration", "Business"],
            showSmallMenu: false,
            isDropdownVisible: false, // Track the visibility of the dropdown
            selectedOption: 'Sort by',
            categories: [], // Will hold categories fetched from API
            selectedCategories: [],
            instructors: [],
            selectedInstructors: [],
        }
    },
    computed: {
        categories() {
            return this.$store.getters.categories
        },
        instructors() {
            return this.$store.getters.instructors
        },
        coureListLength() {
            return this.$store.getters.coureListLength
        }
    },
    methods: {
        showFilterDropdown() {
            this.showSmallMenu = !this.showSmallMenu
        },
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible;
        },
        selectOption(option) {
            this.selectedOption = option;
            this.isDropdownVisible = false; // Close the dropdown after selection
        },
        emitSelectedCategories() {
            this.$store.dispatch("addSelectedCatgories", this.selectedCategories)
        },
        emitSelectedinstractors() {
            this.$store.dispatch("addSelectedInstructor", this.selectedInstructors);
        },
    },
    mounted() {
       // store.dispatch("categoriesList");
       // store.dispatch("instructorsList");
        this.selectedCategories =  store.getters.selectedCategories;
    }
}
</script>
<style scoped>
.page-header.-type-1 .page-header__text {
    color: #666 !important;
}

.custom-select {
    position: relative;
    display: inline-block;
}

.custom-select__button {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid var(--Primary-600, #09445D);
    background-color: #fff;
    font-size: 14px;
    color: #09445D;
    gap: 10px;
}

.custom-select__options {
    display: none;
    position: absolute;
    top: 100%;
    left: -44px;
    right: 0;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 8px;
    margin-top: 5px;
    z-index: 10;
    width: 151px;
    -webkit-box-shadow: 2px 3px 6px #b4c0c07a;
    box-shadow: 2px 3px 6px #b4c0c07a;
}

.custom-select__options a {
    display: block;
    padding: 8px 10px;
    text-decoration: none;
    color: #333;
}

.custom-select__options a:hover {
    background-color: #f1f1f1;
}

/* Show the options when the dropdown is active */
.custom-select.active .custom-select__options {
    display: block;
}
</style>